<template>
  <yxt-dialog
    :visible.sync="states.isShowAIDrawer"
    :destroy-on-close="true"
    :show-header="true"
    :modal="false"
    :append-to-body="true"
    :before-close="beforeClose"
    :lock-scroll="true"
    :fullscreen="true"
    @closed="closed"
  >
    <span slot="mainTitle">
      {{ $t('pc_biz_ote_btn_aicreateques') }}
    </span>
    <span slot="headerRight">
      <yxt-button
        :loading="saving"
        type="primary"
        :disabled="!isReady"
        @click="submit"
        >{{ $t('pc_biz_ote_btn_confirmImport') }}</yxt-button
      >
    </span>
    <intelligent-create-ques
      v-if="quesLevelTypeInited"
      ref="aiQuesCreator"
      :libId="this.states.libId"
      :examId="this.states.examId"
      :type="this.states.type"
      :aiEnable="this.aiEnable"
      @created="quesCreated"
      @createReadyChange="createReadyChange"
    />
  </yxt-dialog>
</template>
<script type='text/ecmascript-6'>
import intelligentCreateQues from './intelligentCreateQues';
import { initQuesLevelType } from './utils';

export default {
  name: 'YxtbizIntelligentQuestioning',
  name_zh: 'AI出题组件',
  eventList: [{
    type: 'created',
    handler: 'quesCreated',
    label: '确认导入试题后触发的事件'
  }, {
    type: 'closed',
    handler: 'closed',
    label: '关闭AI出题的弹框'
  }],
  props: {
    states: {
      type: Object,
      default: () => {
        return {
          isShowAIDrawer: false, // 是否显示出题弹层
          libId: '', // 题库ID
          libName: '', // 题库名
          examId: '', // 试卷ID
          type: 1 // 默认选择  0: 快速出题  1: AI出题
        };
      },
      desc: '控制出题组件内部的参数',
      setter: 'JsonSetter'
    },
    // ai功能是否开启
    aiEnable: {
      type: Boolean,
      default: false,
      desc: 'ai功能是否开启',
      setter: 'BooleanSetter'
    }
  },
  components: {
    intelligentCreateQues
  },
  data() {
    return {
      quesLevelTypeInited: false,
      saving: false,
      isReady: false
    };
  },
  watch: {
    'states.isShowAIDrawer': function(visible) {
      if (visible) {
        document.body.classList.add('yxtbiz-ote-ai-over-hidden');
      } else {
        document.body.classList.remove('yxtbiz-ote-ai-over-hidden');
      }
    }
  },
  created() {
    initQuesLevelType().finally(() => {
      this.quesLevelTypeInited = true;
    });
  },
  computed: {},
  mounted() {},
  methods: {
    quesCreated() {
      // this.states.isShowAIDrawer = false;
      this.$emit('created');
    },
    createReadyChange(isReady) {
      this.isReady = isReady;
    },
    submit() {
      this.saving = this.$refs.aiQuesCreator && this.$refs.aiQuesCreator.saveQuestions(() => {
        this.saving = false;
      });
    },
    beforeClose(done) {
      const hasQues = this.$refs.aiQuesCreator && this.$refs.aiQuesCreator.hasQuesInfos();
      const aiGenerating = this.$refs.aiQuesCreator && this.$refs.aiQuesCreator.aiGenerating();
      if (!hasQues && !aiGenerating) {
        done(true);
        return;
      }

      let closeTip = this.$t('pc_biz_ote_msg_sureclose'); // 确定要关闭吗？
      let closeTittle = this.$t('pc_biz_ote_msg_closeandclearquestip'); // 当前已生成的试题未录入题库，关闭后，试题将会清空，请谨慎操作
      if (aiGenerating) {
        closeTip = this.$t('pc_biz_ote_msg_sureclose'); // 确定要关闭吗？
        closeTittle = this.$t('pc_biz_ote_msg_closestopgenquestip');// 出题过程中关闭页面，也会进行相应试题数量的扣减，请谨慎操作
      }
      // 关闭确认
      this.$confirm(
        closeTittle,
        closeTip,
        {
          confirmButtonText: this.$t('pc_biz_ote_btn_confirm'),
          cancelButtonText: this.$t('pc_biz_ote_btn_cancle'),
          type: 'warning'
        }
      ).then(() => {
        done(true);
      });
    },
    closed() {
      this.$emit('closed');
    }
  },
  beforeDestroy() {
    document.body.classList.remove('yxtbiz-ote-ai-over-hidden');
  }
};
</script>
